'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

function formatIn(value) {
  if (Array.isArray(value) && !(0, _lodash.isEmpty)(value)) {
    return value.map(function (item) {
      if ((0, _lodash.isObject)(item) && !(0, _lodash.isNil)(item)) {
        return item.value;
      }
      return item;
    });
  }
  return value;
}

function formatOut(value, data) {
  var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if ((0, _lodash.isEmpty)(data)) {
    return [];
  }
  return data.map(function (item) {
    return {
      text: item.label,
      value: item.value
    };
  });
}

function defaultValueFormatter(value) {
  if ((0, _lodash.isEmpty)(value)) {
    return '';
  } else {
    return value.map(function (item) {
      if ((0, _lodash.isObject)(item) && !(0, _lodash.isNil)(item)) {
        return item.text;
      }
      return item;
    }).join('/');
  }
}

exports.default = {
  formatIn: formatIn,
  formatOut: formatOut,
  defaultValueFormatter: defaultValueFormatter
};
module.exports = exports['default'];